import { HttpEventType, HttpResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { IBreadcrumbData } from '../../../../interfaces/breadcrumb-data.interface';
import { UploadService } from '../../services/uploads.service';

@Component({
  selector: 'app-uploads',
  templateUrl: './uploads.component.html',
  styleUrls: ['./uploads.component.scss'],
})
export class UploadsComponent implements OnInit, OnDestroy, AfterViewInit {
  public panelOpenState = false;

  private fileInfoSubscription: Subscription;
  private uploadsSubscription: Subscription;

  /**
   * Nuevo método
   */

  public selectedFiles: FileList;
  public currentFile: File;
  public progress = 0;
  public message = '';
  public progressLoaded;

  public fileInfos: any;

  /**
   * BreadcrumbData
   */
  breadcrumbData: IBreadcrumbData;

  constructor(public dialogRef: MatDialogRef<UploadsComponent>, public uploadService: UploadService) {
    this.breadcrumbData = {
      titles: {
        icon: 'settings',
        links: [
          {
            text: 'Normas de uso de la planta',
          },
        ],
      },
      description: 'Aquí se cargan las normas de uso de la planta.',
      buttons: [],
    };
  }

  ngOnInit() {
    this.fileInfoSubscription = this.uploadService.getFiles().subscribe((files) => {
      this.fileInfos = files.data;
    });
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    if (this.uploadsSubscription != null) {
      this.uploadsSubscription.unsubscribe();
    }
    this.fileInfoSubscription.unsubscribe();
  }

  selectFile(event): void {
    this.selectedFiles = event.target.files;
  }
  upload(): void {
    this.progress = 0;

    this.currentFile = this.selectedFiles.item(0);
    this.uploadsSubscription = this.uploadService.upload(this.currentFile).subscribe(
      (event) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progress = Math.round((100 * event.loaded) / event.total);
          this.progressLoaded = event.loaded;
        } else if (event instanceof HttpResponse) {
          if (event.body != null) {
            this.message = event.body.message;
          }
        } else {
          this.fileInfoSubscription = this.uploadService.getFiles().subscribe((files) => {
            this.fileInfos = files.data;
          });
        }
      },
      () => {
        this.progress = 0;
        this.message = 'Could not upload the file!';
        this.currentFile = undefined;
      }
    );
    this.selectedFiles = undefined;
  }
}
